import Chart from 'components/Chart/Chart';
import React, { useEffect, useState } from 'react';
import service from 'services';
import utils from 'utils';
import styled from 'styled-components/macro';
import CommonButton from 'components/Buttons/CommonButton';
import services from 'services';
import Table from 'components/Table';

import { Wrapper } from '../../styles';
import { RangeDate } from '.';

const Title = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  > * {
    margin-right: 10px;
  }
`;

interface Props {
  date: string | Date;
  rangeDate: RangeDate;
  rangeDateActive: boolean;
}

const Mail = (props: Props) => {
  const { date, rangeDate, rangeDateActive } = props;
  const t = utils.intl.useTranslator();
  const [chartData, setChartData] = useState<{ count: number; label: string }[]>([]);
  const [chartMode, setChartMode] = useState('Sent');
  const [tableRows, setTableRows] = useState<any>([]);

  const tableColumns = [
    { accessor: 'company', Header: t('Company') },
    { accessor: 'description', Header: t('Description') },
    { accessor: 'docType', Header: t('Document type') },
    { accessor: 'idCompany', Header: t('Company ID') },
    { accessor: 'idDocType', Header: t('Id doc type') },
    { accessor: 'mail', Header: t('Mail') },
    { accessor: 'sourceStatusTs', Header: t('Source Status') },
    { accessor: 'status', Header: t('Status') },
  ];

  useEffect(() => {
    if (rangeDateActive && !(rangeDate.from && rangeDate.to)) return;

    let dateFrom;
    let dateTo;

    if (rangeDateActive && rangeDate.from && rangeDate.to) {
      dateFrom = utils.date.formatDateForDb(rangeDate.from);
      dateTo = utils.date.formatDateForDb(rangeDate.to);
    } else {
      dateFrom = utils.date.formatDateForDb(date);
      dateTo = utils.date.formatDateForDb(new Date());
    }

    const getMails = async (dateFrom: string, dateTo: string) => {
      let result;
      if (chartMode === 'Sent') {
        const { data } = await service.getSentMail(dateFrom, dateTo);
        result = data;
      } else {
        const { data } = await service.getReceivedMail(dateFrom, dateTo);
        result = data;
      }
      const dataChart = result.map(({ counter, mailAddress }) => ({ count: counter, label: mailAddress }));
      setChartData(dataChart);
      const { data } = await services.getMailStatus();
      setTableRows(data);
    };

    getMails && getMails(dateFrom, dateTo);
  }, [date, chartMode, rangeDate, rangeDateActive]);

  const switchApi = () => {
    chartMode === 'Sent' ? setChartMode('Received') : setChartMode('Sent');
  };

  return (
    <Wrapper>
      <Title>
        <h2>{t('mail_title')}</h2>
        {chartData.length ? (
          <CommonButton id="mail-switch-button" scope="tertiary" customIcon="exchange-alt" action={() => switchApi()} />
        ) : null}
      </Title>
      <Table id="normalizer-mail-table" columns={tableColumns} rows={tableRows} hasFilter hasToolbar />
      {chartData.length ? <Chart title={`${chartMode} mail`} dataValues={chartData} /> : null}
    </Wrapper>
  );
};

export default Mail;
